// import {
//     Column,
// } from 'app/types/simpletable.types'
// import getUniqueId from 'app/utils/getUniqueId'
// import InputSingleline from 'app/shared-components/InputSingleline'
// import Checkbox from 'app/shared-components/Checkbox'
// import EnumSelector from 'app/shared-components/EnumSelector'
// import EnumChipSelector from 'app/shared-components/EnumChipSelector'
// import {
//     OpportunityFrequency, ProductType,
//     DeliveryServiceType, CollectionServiceType,
//     LaneStatus,
// } from 'app/enums/label.enums'
//
// import SkyNetLink, {
//     SizeLink,
//     TypeLink,
// } from 'app/shared-components/SkyNetLink'
// import RemoveFromLG from './RemoveFromLG'
//
//
// const getColumns = ({
//     classes,
//     handleChange,
//     l,
//     getAllowedValues,
//     onRemoveFromLG,
//     getLaneLink,
//     getOpportunityLink,
// }: {
//     classes: Record<string, any>,
//     l: (l: string) => string,
//     handleChange: (...a: any[]) => void,
//     getAllowedValues: (e: Record<string, string>) => Record<string, string>,
//     onRemoveFromLG: ({
//         laneId,
//     }: {
//         laneId: number,
//     }) => void,
//     getLaneLink: (id: string) => string,
//     getOpportunityLink: (id: string) => string,
// }): Column<keyof QuoteLane>[] => {
//     return [
//         {
//             label: '',
//             component: Checkbox,
//             fieldName: 'selected',
//             getProps: ({
//                 id,
//                 selected,
//             }) => {
//                 return {
//                     className: classes.checkbox,
//                     value: selected,
//                     onChange: (checked) => {
//                         handleChange({
//                             id,
//                             selected: checked,
//                         })
//                     },
//                 }
//             },
//             width: 50,
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('AccountQuotes.lanes'),
//             component: SkyNetLink,
//             fieldName: 'laneNumber',
//             getProps: ({
//                 id,
//                 laneNumber,
//             }) => {
//                 return {
//                     disabled: true,
//                     link: getLaneLink(id),
//                     type: TypeLink.EXTERNAL,
//                     text: laneNumber,
//                     size: SizeLink.S,
//                     customClasses: {
//                         wrapper: classes.link,
//                     },
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('AccountLane.opportunity'),
//             component: SkyNetLink,
//             fieldName: 'opportunityNumber',
//             getProps: ({
//                 opportunityId,
//                 opportunityNumber,
//             }) => {
//                 return {
//                     disabled: true,
//                     link: getOpportunityLink(opportunityId),
//                     type: TypeLink.EXTERNAL,
//                     text: opportunityNumber,
//                     size: SizeLink.S,
//                     customClasses: {
//                         wrapper: classes.link,
//                     },
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('AccountQuotes.laneStatus'),
//             component: InputSingleline,
//             getProps: ({
//                 laneStatus,
//             }) => {
//                 return {
//                     classNames: {
//                         label: classes.inputLabel,
//                     },
//                     disabled: true,
//                     value: getAllowedValues(LaneStatus)[laneStatus],
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('LaneBasicView.expPalletsYear'),
//             component: InputSingleline,
//             fieldName: 'expPalletsYear',
//             getProps: () => {
//                 return {
//                     classNames: {
//                         label: classes.inputLabel,
//                     },
//                     disabled: true,
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('Opportunity.frequency'),
//             component: EnumSelector,
//             fieldName: 'frequency',
//             getProps: () => {
//                 return {
//                     className: classes.enumInput,
//                     disabled: true,
//                     allowedValues: getAllowedValues(OpportunityFrequency),
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('AccountQuotes.laneFrom'),
//             component: InputSingleline,
//             fieldName: 'originAirportIataCode',
//             getProps: () => {
//                 return {
//                     classNames: {
//                         label: classes.inputLabel,
//                     },
//                     disabled: true,
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('AccountQuotes.laneTo'),
//             component: InputSingleline,
//             fieldName: 'destAirportIataCode',
//             getProps: () => {
//                 return {
//                     classNames: {
//                         label: classes.inputLabel,
//                     },
//                     disabled: true,
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('LaneGroup.deliveryServiceType'),
//             component: EnumSelector,
//             fieldName: 'deliveryServiceType',
//             getProps: () => {
//                 return {
//                     className: classes.enumInput,
//                     disabled: true,
//                     allowedValues: getAllowedValues(DeliveryServiceType),
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('LaneGroup.collectionServiceType'),
//             component: EnumSelector,
//             fieldName: 'collectionServiceType',
//             getProps: () => {
//                 return {
//                     className: classes.enumInput,
//                     disabled: true,
//                     allowedValues: getAllowedValues(CollectionServiceType),
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('AccountQuotes.productTypes'),
//             component: EnumChipSelector,
//             fieldName: 'productTypes',
//             getProps: () => {
//                 return {
//                     className: classes.enumInput,
//                     disabled: true,
//                     allowedValues: getAllowedValues(ProductType),
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: getLabel('AccountQuotes.laneBaseLeaseDays'),
//             component: InputSingleline,
//             fieldName: 'baseLeaseDays',
//             getProps: ({
//                 baseLeaseDays,
//             }) => {
//                 return {
//                     classNames: {
//                         label: classes.inputLabel,
//                     },
//                     disabled: true,
//                     value: (baseLeaseDays || []).join(';'),
//                 }
//             },
//             id: getUniqueId(),
//         },
//         {
//             label: '',
//             component: RemoveFromLG,
//             getProps: ({
//                 laneStatus,
//                 id,
//             }) => {
//                 return {
//                     laneStatus,
//                     onRemoveFromLG,
//                     laneId: id,
//                 }
//             },
//             id: getUniqueId(),
//         },
//     ]
// }
//
// export default getColumns

import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    OpportunityFrequency,
    ProductType,
    DeliveryServiceType,
    CollectionServiceType,
    LaneStatus,
} from 'app/enums/label.enums'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LinkConfig,
} from 'app/Apps/DomainObject/ComponentMapper/SkyNetTableLink'

export type QuoteLane = {
    changedOn: string,
    laneStatus: LaneStatus,
    destAirportIataCode: string,
    id: number,
    laneComment: string,
    laneNumber: string,
    originAirportIataCode: string,
    selected: boolean,
    opportunityNumber: string,
    expPalletsYear: number,
    frequency: OpportunityFrequency,
    deliveryServiceType: DeliveryServiceType,
    collectionServiceType: CollectionServiceType,
    productTypes: ProductType[],
    baseLeaseDays: number[]
}

const columns = ({
    getLabel,
    laneLinkConfig,
    opportunityLinkConfig,
}: {
    getLabel: (l: string) => string
    laneLinkConfig?: LinkConfig,
    opportunityLinkConfig?: LinkConfig
}): RichTableColumns<keyof QuoteLane>[] => {
    return [
        {
            id: 'laneNumber',
            headerProps: {
                children: getLabel('AccountQuotes.lanes'),
            },
            mapCellProps: 'laneNumber',
            componentName: 'SkyNetTableLink',
            type: TypeLink.EXTERNAL,
            size: SizeLink.S,
            linkConfig: laneLinkConfig,
            width: '120px',
        },
        {
            id: 'opportunityNumber',
            headerProps: {
                children: getLabel('AccountLane.opportunity'),
            },
            mapCellProps: 'opportunityNumber',
            componentName: 'SkyNetTableLink',
            type: TypeLink.EXTERNAL,
            size: SizeLink.S,
            linkConfig: opportunityLinkConfig,
            width: '120px',
        },
        {
            id: 'laneStatus',
            headerProps: {
                children: getLabel('AccountQuotes.laneStatus'),
            },
            filterField: 'laneStatus',
            filterType: FilterType.Array,
            mapCellProps: 'laneStatus',
            componentName: 'EnumValue',
            allowedValuesEnum: LaneStatus,
        },
        {
            id: 'expPalletsYear',
            headerProps: {
                children: getLabel('LaneBasicView.expPalletsYear'),
            },
            mapCellProps: 'expPalletsYear',
        },
        {
            id: 'frequency',
            headerProps: {
                children: getLabel('Opportunity.frequency'),
            },
            filterField: 'frequency',
            filterType: FilterType.Array,
            mapCellProps: 'frequency',
            componentName: 'EnumValue',
            allowedValuesEnum: OpportunityFrequency,
        },
        {
            id: 'originAirportIataCode',
            headerProps: {
                children: getLabel('AccountQuotes.laneFrom'),
            },
            filterField: 'originAirportIataCode',
            filterType: FilterType.Array,
            mapCellProps: 'originAirportIataCode',
        },
        {
            id: 'destAirportIataCode',
            headerProps: {
                children: getLabel('AccountQuotes.laneTo'),
            },
            filterField: 'destAirportIataCode',
            filterType: FilterType.Array,
            mapCellProps: 'destAirportIataCode',
        },
        {
            id: 'deliveryServiceType',
            headerProps: {
                children: getLabel('LaneGroup.deliveryServiceType'),
            },
            mapCellProps: 'deliveryServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: DeliveryServiceType,
        },
        {
            id: 'collectionServiceType',
            headerProps: {
                children: getLabel('LaneGroup.collectionServiceType'),
            },
            mapCellProps: 'collectionServiceType',
            componentName: 'EnumValue',
            allowedValuesEnum: CollectionServiceType,
        },
        {
            id: 'productTypes',
            headerProps: {
                children: getLabel('AccountQuotes.productTypes'),
            },
            mapCellProps: 'productTypes',
            componentName: 'EnumList',
            allowedValuesEnum: ProductType,
            minWidth: '150px',
        },
        {
            id: 'baseLeaseDays',
            headerProps: {
                children: getLabel('AccountQuotes.laneBaseLeaseDays'),
            },
            mapCellProps: ({
                baseLeaseDays,
            }) => {
                return {
                    children: baseLeaseDays.join(', '),
                }
            },
        },
    ]
}

export default columns
